export default "__VITE_ASSET__6599ae7f__"